<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      <p>
        &copy; 2026
        <a href="https://www.vpn-free.com" class="footer-link">vpn-free.com</a>
        {{ nav.footerNote }}
      </p>
    </div>
    <div class="footer-links">
      <a href="/about-us/" class="footer-link">{{ nav.about }}</a>
      <span>|</span>
      <a href="/disclaimer/" class="footer-link">{{ nav.disclaimer }}</a>
      <span>|</span>
      <a href="/privacy-policy/" class="footer-link">{{ nav.privacy }}</a>
      <span>|</span>
      <a href="/terms-of-use/" class="footer-link">{{ nav.terms }}</a>
      <span>|</span>
      <a href="/contact-us/" class="footer-link">{{ nav.contact }}</a>
    </div>
  </div>
</footer>
</template>

<script>
import { getNavigationCopy } from '@/data/vpnNavigation';

export default {
  name: 'Footer',
  computed: {
    nav() {
      const localeKey = (this.$route && this.$route.meta && this.$route.meta.localeKey) || 'en';
      return getNavigationCopy(localeKey);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: #fff;
  color: var(--vpn-ink, #1f2430);
  padding: 20px 0;
  border-top: 1px solid var(--vpn-line, #e8e4f8);
}

.footer-container {
  width: var(--vpn-content-width);
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  color: var(--vpn-ink-muted, #5b6475);
  font-size: 14px;
}

.footer-link {
  color: var(--vpn-brand, #6d4aff);
  text-decoration: none;
  font-size: 14px;
}

.footer-link:hover {
  color: var(--vpn-brand-deep, #5b3fe8);
}

.footer-note {
  font-size: 14px;
  color: var(--vpn-ink-muted, #5b6475);

  p {
    margin: 0;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 16px 0 24px;
  }

  .footer-container {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;
    flex-direction: column;
    text-align: center;
  }

  .footer-links {
    justify-content: center;
    gap: 6px 8px;
    font-size: 13px;
  }

  .footer-link {
    font-size: 13px;
  }

  .footer-note {
    font-size: 12px;
    line-height: 1.5;
  }
}

@media (max-width: 480px) {
  .footer-container {
    padding-left: 12px;
    padding-right: 12px;
  }

  // 窄屏隐藏分隔符，链接自然换行更整齐
  .footer-links span {
    display: none;
  }

  .footer-links {
    gap: 10px 14px;
  }
}
</style>
